
/**
 * 투표 유형
 */
export type VoteReviewBodyVote = typeof VoteReviewBodyVote[keyof typeof VoteReviewBodyVote];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VoteReviewBodyVote = {
  HELPFUL: 'HELPFUL',
  UNHELPFUL: 'UNHELPFUL',
} as const;
